import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUserGroup } from '@boldpenguin/sdk';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserGroupsService {
  readonly authBaseUrl = environment.apiAuthUri;

  constructor(private http: HttpClient) {}

  getUserGroups(): Observable<IUserGroup[]> {
    const url = `${this.authBaseUrl}/api/terminal/user_groups`;
    return this.http.get<IUserGroup[]>(url);
  }
}
